import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_MAINTENANCE_BASIC_ACTIVITIES,
  CLEAR_MAINTENANCE_CHECKLIST,
  CLEAR_MAINTENANCE_CHECKLISTS,
  FLAG_GETTING_MAINTENANCE_BASIC_ACTIVITIES,
  FLAG_GETTING_MAINTENANCE_CHECKLISTS,
  FLAG_MAINTENANCE_CHECKLIST_ACTIVITY,
  GET_MAINTENANCE_BASIC_ACTIVITIES,
  GET_MAINTENANCE_CHECKLIST,
  GET_MAINTENANCE_CHECKLISTS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  basicActivities: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_CHECKLISTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_CHECKLISTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_CHECKLISTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_MAINTENANCE_CHECKLIST_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_MAINTENANCE_CHECKLIST:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_CHECKLIST:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_GETTING_MAINTENANCE_BASIC_ACTIVITIES:
      return state.setIn(['basicActivities', 'loading'], payload);
    case GET_MAINTENANCE_BASIC_ACTIVITIES:
      return state.setIn(
        ['basicActivities', 'content'],
        Immutable.Map(payload),
      );
    case CLEAR_MAINTENANCE_BASIC_ACTIVITIES:
      return state.setIn(
        ['basicActivities', 'content'],
        INITIAL_STATE.getIn(['basicActivities', 'content']),
      );
    default:
      return state;
  }
};
